<template>
    <v-chip pill :color="dark ? '#555' : '#666'" text-color="white">
        <v-avatar v-bind="avatarSettings" :color="dark ? '#444' : '#555'">
            <v-icon>{{ icon }}</v-icon>
        </v-avatar>
        {{ ucFirst(value) }}
    </v-chip>
</template>

<script>

export default {

    components: {},

    props: {
        type: {
            required: true,
            type: String
        },
        text: {
            required: false,
            type: String,
            default: null
        },
        dark: {
            required: false,
            type: Boolean,
            default: false,
        }
    },

    computed: {

        avatarSettings() {

            let object = {};

            if (this.value.length === 0) {
                return object;
            }

            // Align left if there is text
            object['left'] = true;

            return object;
        },

        value() {
            return this.text === null ? this.type : this.text;
        },

        icon() {
            return this.$store.state.dataVariableIcons[this.type];
        }
    }
}
</script>
